




import { Component } from 'vue-property-decorator';
import { HeaderConfig, EntityList } from '@/base';
import store from '../store';
import { CostCenterJson } from '../json';
import { UserPermission } from '@/modules/user';

@Component<List>({
  created()
  {
    this.init();
  },
})
export default class List extends EntityList<CostCenterJson, typeof store>
{
  protected hasWritePermission(): boolean {
    return this.hasPermission(UserPermission.MASTER_DATA_WRITE);
  }

  /**
   * The store to the items.
   */
  protected readonly store = store;

  public sortState = [{ property: 'name' }];

  /**
   * Returns the columns of the table (excluding actions and id).
   */
  protected getColumns(): HeaderConfig[]
  {
    return [
      {
        value: 'name',
        text: this.$t('list.header.name').toString(),
      },
    ];
  }

  protected getDeleteConfirmationMessage(item: CostCenterJson): { title?: string; message: string }
  {
    return {
      title: this.$t('list.delete.title', item).toString(),
      message: this.$t('list.delete.message', item).toString(),
    };
  }
}
